export const restrictedData: string[] = []